module.exports = __webpack_public_path__ + "media/aloe-medium.d51c400e.mp4";